import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { MediaObserver } from '@angular/flex-layout';
import * as moment from 'moment';
import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';
import { DialogsService } from 'src/app/services/manage/dialogs/dialogs.service';
import { cloneDeep } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AlertExpireDateProductDialogComponent } from 'src/app/components/dialogs/alert-expire-date-product-dialog/alert-expire-date-product-dialog.component';
import { PanierService } from "../../../../services/manage/panier/panier.service";
import { SalemethodService } from "../../../../services/api/salemethod/salemethod.service";

@Component({
  selector: 'app-date-order',
  templateUrl: './date-order.component.html',
  styleUrls: ['./date-order.component.css'],
})

export class DateOrderComponent implements OnInit {

  @Input()
  error: string | any;
  @Output()
  clearErrorEvent: EventEmitter<any> = new EventEmitter();

  closings: any;
  // opening: any; (DEPRECATED)
  timetables: any;
  currHours: any = [];
  currDate: any;
  currHour: any;
  minDate = moment();
  gapNeeded: boolean = false;
  pointOfSale: any = this.tools.getStor("point_of_sale");
  saleMethod: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
  loaders: any = {
    hours: false
  };
  closedForToday: boolean = false;
  cloneHourCurrInit: any;
  cloneCurrDate: any;
  clonecurrHour: any;
  init: boolean = false;
  messagecommande: boolean = false;
  hoursIschanged: boolean = false;
  dateIschanged: boolean = false;
  basket: any;

  closedDays: any[] = [];
  daysClosedLoaded = false;

  constructor(
    public media: MediaObserver,
    public dialService: DialogsService,
    private tools: ToolsService,
    private orderApi: ClientOrdersService,
    public translate: TranslateService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.initData();
  }

  ngOnChanges(changes: SimpleChanges | any): void {
    if (changes.error.currentValue && changes.error.currentValue === 'invalidhour' || changes.error.currentValue === 'invalidslot') {
      // if (changes.error.currentValue === 'invalidslot') {
      this.clearError();
      this.setDate();
      // }
      // else {
      //   this.removeHour();
      //   this.changeHours();
      // }
      this.scrollToError();
      this.checkChangeHours(changes.error.currentValue);
    } else if (changes.error.currentValue && changes.error.currentValue === 'invalidDate') {
      this.currDate = moment();
      this.setDate();
      this.scrollToError();
      this.checkChangeHours(changes.error.currentValue);
    }
  }

  initData() {
    const dateOrder = this.tools.getStor("date_order");
    const hourOrder = this.tools.getStor("hour_order");
    this.closings = this.pointOfSale.closings;
    // this.opening = this.pointOfSale.opening; (DEPRECATED)
    this.timetables = this.getValidTimeTables();
    if (dateOrder) {
      //current date enregistrée au depart
      this.currDate = moment(dateOrder);
    }
    if (hourOrder) {
      //current heure enregistrée
      this.currHour = moment(hourOrder).format("HH:mm");
      //on clone la current heure pour savoir si un changement a ete effectué
      this.clonecurrHour = moment(hourOrder).format("HH:mm");
    }
    //variable pour savoir si demarrage
    this.init = true;
    //on set la date
    this.setDate();
  }

  getValidTimeTables(): any[] {
    let validTimeTables = this.pointOfSale.timetables;
    if (this.pointOfSale.timetables_sm) {
      for (let index = 0; index < this.pointOfSale.timetables_sm.length; index++) {
        const timeTable = this.pointOfSale.timetables_sm[index];
        if (timeTable.id_sale_method === this.saleMethod.id) {
          validTimeTables = timeTable.timetables;
          break;
        }
      }
    }
    return validTimeTables;
  }

  checkOpenedDate(currMoment: moment.Moment): boolean {
    if (!currMoment) return false;

    let isOpen = true;

    // 1) timetables (jour sans timeslots => fermé)
    this.timetables?.forEach((day: any) => {
      if (day.day === currMoment.day() && (!day.timeslots || day.timeslots.length < 1)) {
        isOpen = false;
      }
    });

    // 2) closing (périodes de fermeture)
    if (this.closings?.length && isOpen) {
      for (const period of this.closings) {
        if (currMoment.isBetween(period.close_from, period.close_to, "day", "[]")) {
          isOpen = false;
          break;
        }
      }
    }

    // 3) closedDays (fermetures calculées / renvoyées par l’API)
    if (this.closedDays?.length && isOpen) {
      for (const period of this.closedDays) {
        if (currMoment.isBetween(period.DATE_FROM, period.DATE_TO, "day", "[]")) {
          isOpen = false;
          break;
        }
      }
    }

    // 4) opening  (DEPRECATED)
    // if (this.opening?.length) {
    //   let openingFlag = false;
    //   for (const period of this.opening) {
    //     if (currMoment.isBetween(period.open_from, period.open_to, "day", "[]")) {
    //       openingFlag = true;
    //       break;
    //     }
    //   }
    //   isOpen = openingFlag;
    // }

    return isOpen;
  }

  filterDate = (date: moment.Moment | null): boolean => {
    if (!date) return false;

    const min = this.minDate ? moment(this.minDate) : moment();
    if (date.isBefore(min, "day")) return false;

    return this.checkOpenedDate(date);
  };

  setDate(): void {
    //on enregistre le clone avant le changement de la current date
    this.cloneCurrDate = cloneDeep(moment(this.tools.getStor("date_order")));
    //changement de la current date
    //on modifie la current date dans le localstorage
    this.tools.setStor("date_order", this.currDate);
    //on supprime les heures enregistrées
    this.removeHour();
    //on va chercher les nouveaux horaires
    this.changeHours();
    //on verifie si mode de paiement  counter maxi 4 jours de differences
    // affichage erreur
    this.checkCounterDate();
  }

  setHour(): void {
    //on set hour la nouvelle heure
    const dateTime = moment(this.currDate.format("DD/MM/YYYY") + ' ' + this.currHour, 'DD/MM/YYYY HH:mm');
    this.tools.setStor("hour_order", dateTime);
    //on clone
    this.clonecurrHour = cloneDeep(this.currHour);
  }

  removeDate() {
    this.currDate = null;
    this.tools.removeStor("date_order");
  }

  removeHour() {
    this.currHour = null;
    this.tools.removeStor("hour_order");
  }

  changeHours(): void {
    this.closedForToday = false;
    this.gapNeeded = false;
    this.currHours = [];
    this.loaders.hours = true;
    this.hoursIschanged = false;
    //on recupere les dates et heures valident
    //on partant du jour et de l'heure de depart
    this.basket = this.tools.getStor(PanierService.TAG_STORAGE) ? this.tools.getStor(PanierService.TAG_STORAGE) : null;
    if (!this.basket) {
      return;
    }
    this.orderApi.getValidSlots(this.currDate, this.clonecurrHour, this.basket).then(datas => {
      //checkProducts
      if (datas.code && datas.code < 0 && datas.code != -201) {
        this.tools.openSnackBar(datas.message, "warn", 4000);
        this.loaders.hours = false;
      } else {
        if (datas.code && datas.code < 0 && datas.code == -201) {
          let error = {
            "ids_notmatched": datas.ids_notmatched
          }
          this.openAlertProductValidty(error);
        }
        let data = datas.code && datas.code < 0 && datas.code == -201 ? datas.validHours : datas;
        const validHours = data.valid_slots.filter((hour: any) => hour.available);
        this.currHours = data.valid_slots;
        this.closedDays = data.daysclosed ? data.daysclosed : [];
        if (data.day_changed) {
          this.gapNeeded = true;
          this.currDate = moment(data.day_changed);
          // this.minDate = moment(data.day_changed);
          this.tools.setStor("date_order", this.currDate);
        }
        if (data.valid_slots.length > 0) {
          if (!this.currHour) {
            if (validHours.length > 0 && validHours[0].available) {
              //si la date est l'heure sont superieur validHours[0].available
              //calcul pour comparer les dates et heures
              const oldclonecurrHourFormated = moment(this.cloneCurrDate.format("DD/MM/YYYY") + ' ' + this.clonecurrHour, ' HH:mm');
              const newCurrentValidHoursFormated = moment(this.currDate.format("DD/MM/YYYY") + ' ' + validHours[0].hour, ' HH:mm');
              if (this.currDate.format("DD/MM/YYYY") == this.cloneCurrDate.format("DD/MM/YYYY")) {
                //la date n'a pas changée
                //si la nouvelle valeur est inferieur à l'heure  choisie
                //on ne modifie pas
                this.currHour = this.clonecurrHour && (oldclonecurrHourFormated >= newCurrentValidHoursFormated) ? this.clonecurrHour : validHours[0].hour;
                this.hoursIschanged = this.clonecurrHour && (oldclonecurrHourFormated >= newCurrentValidHoursFormated) ? false : true;
                this.dateIschanged = false;
              }
              else {
                //la date a changée donc on modifie la date et l'heure
                this.currHour = validHours[0].hour;
                this.dateIschanged = true;
                this.hoursIschanged = true;
              }
              //on recupere les nouvelles heures
              this.setHour();
              //check  si heure ou date a changée pour l'affichage toolbar
              // au demarrage ou invalid slot
              if (this.init || (this.error && this.error == 'invalidslot' && this.hoursIschanged) || this.hoursIschanged) {
                this.checkChangeHours();
              }
            }
          } else {
            this.setHourWithCurrHour(validHours);
          }
        } else {
          this.closedForToday = true;
        }
        this.loaders.hours = false;
      }
      this.init = false;
    });
  }

  setHourWithCurrHour(slotHours: any) {
    for (let a = 0; a < this.currHours.length; a++) {
      const hour = this.currHours[a];
      if (hour.hour === this.currHour) {
        if (!hour.available) {
          this.removeHour();
          this.currHour = slotHours[0].hour;
          this.setHour();
        } break;
      }
    }
  }

  // Check on local storage
  checkOnStor(what: string): any {
    return this.tools.getStor(what);
  }

  // Check if date is enable to counter payment
  checkCounterDate() {
    const currSm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    if (currSm.payment_type === "secure_counter") {
      (this.currDate.isAfter(moment().add(4, 'days'))) ? this.error = "counterdate" : (this.error === "counterdate") ? this.error = "" : "";
    }
  }

  clearError(): void {
    setTimeout(() => {
      this.clearErrorEvent.emit(null);
    }, 0);
  }

  // check if date or hour  has changed
  checkChangeHours(checkerror?: any) {
    //changement jour et heure ou   changement d'heure
    if (this.dateIschanged || this.hoursIschanged) {
      //
      let result = this.translate.instant('DateOrderComponent.warn');
      result += this.dateIschanged || (this.dateIschanged && this.hoursIschanged) ? this.translate.instant('DateOrderComponent.date') : this.translate.instant('DateOrderComponent.hour');
      result += this.translate.instant('DateOrderComponent.orderHandle');
      let classVar: any = checkerror ? 'warn' : 'primary';
      let time = checkerror ? 1500 : 0;
      //on fait tourner les spinners
      this.loaders.hours = true;
      setTimeout(() => {
        this.loaders.hours = false;
        this.tools.openSnackBar(result, classVar, 5000, "top");
      }, time);
      //erreur
      if (this.error) {
        setTimeout(() => {
          this.error = null;
          this.messagecommande = true;
        }, 1500);
        setTimeout(() => {
          this.messagecommande = false;
        }, 15000);
      }
      //on remet tout  à zero
      this.dateIschanged = false;
      this.hoursIschanged = false;
    }
    // }
  }

  scrollToError() {
    setTimeout(() => {
      const objDiv: any = document.getElementById("invalid");
      if (objDiv) {
        objDiv.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);
  }

  debugg() {
  }

  openAlertProductValidty(errProductValidity: any) {
    const myConf = new MatDialogConfig();
    myConf.data = { errProductValidity: errProductValidity }
    myConf.panelClass = "dialog-responsive"
    this.media.isActive("xs")
      ? (myConf.width = "100%")
      : (myConf.width = "550px");
    const myDial = this.dialog.open(AlertExpireDateProductDialogComponent, myConf);
    myDial.afterClosed().subscribe(data => {
    })
  }
}
